export default __webpack_public_path__ + "static/media/category_energy.2a227caf.svg";